/* eslint-disable class-methods-use-this */
import type { ILOidcLocation } from '@axa-fr/react-oidc';

const isValidQuery = (query: string) => {
  if (!query || query.length > 2048) return false;
  try {
    const params = new URLSearchParams(query);
    const entries = Array.from(params.entries());

    return entries.every(([_, value]) => {
      const decoded = decodeURIComponent(value);
      if (decoded.startsWith('http')) {
        return new URL(decoded).origin === window.location.origin;
      }
      return true;
    });
  } catch {
    return false;
  }
};

const isValidPath = (path: string) => /^[a-zA-Z0-9/_-]*$/.test(path);

export class OidcLocation implements ILOidcLocation {
  getCurrentHref() {
    return window.location.href;
  }

  getOrigin(): string {
    return window.origin;
  }

  getPath() {
    const { location } = window;
    const safePath = isValidPath(location.pathname) ? location.pathname : '/';
    const safeSearch = isValidQuery(location.search) ? location.search : '';
    const safeHash = location.hash.startsWith('#') ? location.hash : '';
    return safePath + safeSearch + safeHash;
  }

  open(url: string) {
    window.location.replace(url);
  }

  reload() {
    window.location.reload();
  }
}
